import React from "react";

/**
 * EmptyState - Centred placeholder shown when a list has no items.
 *
 * Usage:
 *   <EmptyState message="No rows added yet." />
 */
const EmptyState = ({ message }) => (
  <div className="mt-3 py-4 border rounded bg-light d-flex justify-content-center align-items-center">
    <span className="text-muted small">{message}</span>
  </div>
);

export default EmptyState;
